import {
  PrintingService,
  ResponsePrintingServiceProps,
  PrintingServiceList,
} from '../../../types/printingService/PrintingService';

export const LIST_PRINTING_SERVICE = 'LIST_PRINTING_SERVICE';
export const SHOW_PRINTING_SERVICE = 'SHOW_PRINTING_SERVICE';
export const UPDATE_PRINTING_SERVICE = 'UPDATE_PRINTING_SERVICE';
export const CREATE_PRINTING_SERVICE = 'CREATE_PRINTING_SERVICE';
export const DELETE_PRINTING_SERVICE = 'DELETE_PRINTING_SERVICE';
export const PRINTING_SERVICE_LIST = 'PRINTING_SERVICE_LIST';
export const RESET_PRINTING_SERVICE_STATE = 'RESET_PRINTING_SERVICE_STATE';

interface ActionListPrintingService {
  type: typeof LIST_PRINTING_SERVICE;
  payload: ResponsePrintingServiceProps;
}

interface ActionShowPrintingService {
  type: typeof SHOW_PRINTING_SERVICE;
  payload: PrintingService;
}

interface ActionUpdatePrintingService {
  type: typeof UPDATE_PRINTING_SERVICE;
  payload: PrintingService;
}

interface ActionDeletePrintingService {
  type: typeof DELETE_PRINTING_SERVICE;
  payload: string;
}

interface ActionResetPrintingServiceState {
  type: typeof RESET_PRINTING_SERVICE_STATE;
}

interface ActionCreatePrintingService {
  type: typeof CREATE_PRINTING_SERVICE;
  payload: PrintingService;
}

export interface ActionPrintingServiceList {
  type: typeof PRINTING_SERVICE_LIST;
  payload: PrintingServiceList[];
}

export type TypesActionsPrintingService =
  | ActionListPrintingService
  | ActionShowPrintingService
  | ActionUpdatePrintingService
  | ActionDeletePrintingService
  | ActionResetPrintingServiceState
  | ActionCreatePrintingService
  | ActionPrintingServiceList;
